import { render, staticRenderFns } from "./AgentComission.vue?vue&type=template&id=5ce2cab6&"
import script from "./AgentComission.vue?vue&type=script&lang=js&"
export * from "./AgentComission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports